import { render, staticRenderFns } from "./pricing-compare.vue?vue&type=template&id=1ed188d6&scoped=true&"
import script from "./pricing-compare.vue?vue&type=script&lang=js&"
export * from "./pricing-compare.vue?vue&type=script&lang=js&"
import style0 from "./pricing-compare.vue?vue&type=style&index=0&id=1ed188d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed188d6",
  null
  
)

export default component.exports